<template>
  <section class="d-flex flex-column h-full">
    <div class="w-full">
      <header class="mdc-top-app-bar position-static" id="app-bar" ref="appBar">
        <div class="mdc-top-app-bar__row">
          <section class="mdc-top-app-bar__section title">
            <div class="mdc-top-app-bar__title">
              {{ title }}
            </div>
          </section>
        </div>
      </header>
    </div>
    <div class="flex-grow-1 scroll-y bg-white">
      <section>
        <form @submit.prevent="changePassword()" novalidate>
          <div class="pda-default">
            <div class="t-headline5">
              {{ $t("S20068") }}
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
              {{ $t("S20069") }}
            </div>
          </div>

          <div class="pda-default mgt-4">
            <div class="">
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                :class="
                  submitState && newPasswordInvalidCheck
                    ? 'mdc-text-field--invalid'
                    : ''
                "
                id="newPasswordEl"
              >
                <i class="material-icons mdc-text-field__icon">
                  {{ newPasswordValidIcon }}
                </i>
                <input
                  type="password"
                  class="mdc-text-field__input"
                  v-model="newPassword"
                  v-validate="'required|min:10|verify_password'"
                  ref="newPassword"
                  id="newPassword"
                  name="newPassword"
                  maxlength="50"
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      {{ $t("S20070") }}
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <div
                class="t-helper mgl-7 mgr-7 pdt-2 min-h-23"
                :class="
                  submitState && newPasswordInvalidCheck ? 't-color-red1' : ''
                "
              >
                <span
                  :class="
                    submitState && newPasswordInvalidCheck ? 't-color-red1' : ''
                  "
                >
                  {{ $t("S20072") }}
                </span>
              </div>

              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-17"
                :class="
                  submitState && newPasswordConfirmInvalidCheck
                    ? 'mdc-text-field--invalid'
                    : ''
                "
                id="newPasswordConfirmEl"
              >
                <i class="material-icons mdc-text-field__icon">
                  {{ newPasswordConfirmValidIcon }}
                </i>
                <input
                  type="password"
                  class="mdc-text-field__input"
                  v-model="newPasswordConfirm"
                  v-validate="'required|confirmed:newPassword'"
                  ref="newPasswordConfirm"
                  id="newPasswordConfirm"
                  name="newPasswordConfirm"
                  maxlength="50"
                />
                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      {{ $t("S20071") }}
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <div
                class="t-helper mgl-7 mgr-7 pdt-2 min-h-23"
                :class="
                  submitState && newPasswordConfirmInvalidCheck
                    ? 't-color-red1'
                    : ''
                "
              >
                <span
                  :class="
                    submitState && newPasswordConfirmInvalidCheck
                      ? 't-color-red1'
                      : ''
                  "
                >
                  {{ $t("S20073") }}
                </span>
              </div>

              <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-red1">
                <span
                  v-show="submitState && newPasswordConfirmInvalidCheck"
                ></span>
              </div>
            </div>

            <div class="mgt-50">
              <button class="mdc-button mdc-button--raised btn-red mr8">
                {{ $t("S20074") }}
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </section>
</template>
  
  <script>
import { mapMutations } from "vuex";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi.js";
import loginApi from "@/api/loginApi.js";
import { commonMixin } from "@/mixins/common.js";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBar from "@/components/TopAppBar.vue";

export default {
  components: {
    TopAppBar,
  },

  mixins: [commonMixin, topAppBarMixin],

  data() {
    return {
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      currentPasswordTextField: null,
      newPasswordTextField: null,
      newPasswordConfirmTextField: null,
      submitState: false,
      newPasswordValidIcon: "",
      newPasswordConfirmValidIcon: "",
      params: "",
      redirectPath: "",
      popupData: null,
      popupImage: null,
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      socialAuth: false,
      isDrawerOpen: false,
      staticMode: "",
      next: "",
    };
  },

  computed: {
    newPasswordInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("newPassword")) {
          returnValue = true;
          this.newPasswordValidIcon = "warning";
        } else {
          returnValue = false;
          this.newPasswordValidIcon = "check";
        }
      }
      this.newPasswordTextField.valid === !returnValue
        ? ""
        : (this.newPasswordTextField.valid = !returnValue);
      return returnValue;
    },

    newPasswordConfirmInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("newPasswordConfirm")) {
          returnValue = true;
          this.newPasswordConfirmValidIcon = "warning";
        } else {
          returnValue = false;
          this.newPasswordConfirmValidIcon = "check";
        }
      }
      this.newPasswordConfirmTextField.valid === !returnValue
        ? ""
        : (this.newPasswordConfirmTextField.valid = !returnValue);
      return returnValue;
    },
  },

  mounted() {
    this.setMaterialUi();
    this.$refs.newPassword.focus();
    this.paramsss = JSON.parse(localStorage.getItem("userParams"));
  },
  created() {
    localStorage.setItem("learn", "setChangePassword");
  },
  methods: {
    setMaterialUi() {
      this.newPasswordTextField = new MDCTextField(
        document.querySelector("#newPasswordEl")
      );
      this.newPasswordTextField.useNativeValidation = false;
      this.newPasswordConfirmTextField = new MDCTextField(
        document.querySelector("#newPasswordConfirmEl")
      );
      this.newPasswordConfirmTextField.useNativeValidation = false;

      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },

    ...mapMutations("join", [
      "SET_JOINSTART",
      "SET_SOCIAL_LINK",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    changePassword() {
      this.$validator.validateAll().then((resultValid) => {
        this.submitState = true;
        if (resultValid) {
          let params = {
            password: this.paramsss.password,
            newPassword: this.newPassword,
          };
          let responseData = null;
          let alertParams = null;
          memberApi
            .changePassword(params)
            .then((response) => {
              responseData = response.data.data;

              if (responseData) {
                alertParams = {
                  title: this.$t("325"),
                  content: this.$t("326"),
                  accept: this.$t("328"),
                };

                this.$alert(alertParams).then(() => {
                  let paramss = {
                    userId: this.paramsss.userId,
                    password: this.newPassword,
                    device: {
                      type: this.paramsss.device.type,
                    },
                  };
                  this.checkSignInStatus(paramss);
                });
              } else {
                this.$snackOpen({
                  contents: this.$t(
                    "Todo-비밀번호 변경에 실패하였습니다. 관리자에게 문의 바랍니다."
                  ),
                }).then(() => {});
              }
            })
            .catch((err) => {
              responseData = err.response.data.meta;
              this.$snackOpen({
                contents: this.$t("344"),
                btnDisplayYN: true,
                btnDisplay: this.$t("345"),
              }).then(() => {});
            });
        }
      });
    },
    checkSignInStatus(paramss) {
      loginApi
        .login(paramss)
        .then((response) => {
          let responseData = response.data.data;
          let changePasswordRequest = responseData.changePasswordRequest;
          let reIssueChangePassword = responseData.reIssueChangePassword;
          let emailAuth = responseData.emailAuth;
          let dormancy = responseData.dormancy;
          let responsibilityAuth = responseData.responsibilityAuth;
          let termsAgree = responseData.termsAgree;
          loginApi.setAuthInHeader(responseData.token);
          localStorage.setItem("userParams", JSON.stringify(paramss));

          if (dormancy === true) {
            this.$alert({
              title: this.$t("824"),
              content:
                this.$t("825") +
                " " +
                this.$t("826") +
                "<br>" +
                this.$t("827", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("828", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("829"),
            })
              .then(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              });
          } else if (termsAgree === false) {
            this.$router.push("/termsagree");
          } else if (emailAuth === false) {
            this.$confirm({
              title: this.$t("804"),
              content: this.$t("805") + " " + this.$t("806"),
              accept: this.$t("835"),
              cancel: this.$t("834"),
            })
              .then(() => {
                this.$router.push("/emailvarification");
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              });
          } else if (changePasswordRequest === true && this.next == "") {
            this.$router.push({ name: "MemberChangePassword" });
          } else if (reIssueChangePassword === true) {
            this.$router.push({ name: "MemberReIssueChangePassword" });
          } else if (responsibilityAuth === false) {
            this.$alert({
              title: this.$t("830"),
              content: this.$t("831") + " " + this.$t("832"),
              accept: this.$t("833"),
            })
              .then(() => {
                this.$router.push("/verificationcode");
              })
              .catch(() => {
                //this.$router.push('/login')
              });
          } else {
            loginApi.setAuthInHeader(responseData.token);
            // Redirect URL
            console.log("8888888888888888888888888888888check1");

            this.redirectPath = this.$route.query.redirectPath || "/home";
            this.title = localStorage.getItem("brandName") || this.$t("286");
            this.callPushNotification();
            this.$router.push(this.redirectPath);
          }
        })
        .catch((err) => {
          console.log("Change Password Login Flow Error : ", err);
          const responseData = err.response.data.meta;

          console.log("responseData", responseData);

          if (responseData.errCode === 1201) {
            //관리자 승인 대기중(Waiting for administrator approval)
            // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
            //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1202) {
            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1204) {
            this.$alert({
              title: this.$t("1482"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1483") +
                "<br>" +
                this.$t("1484") +
                ": " +
                '<a href="mailto:' +
                BRAND_MANAGER_EMAIL +
                '">' +
                BRAND_MANAGER_EMAIL +
                "</a>" +
                "<br>" +
                this.$t("1485") +
                ": " +
                '<a href="tel:' +
                BRAND_MANAGER_PHONE +
                '">' +
                BRAND_MANAGER_PHONE +
                "</a>",
              accept: this.$t("1486"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1205) {
            this.$alert({
              title: this.$t("1914"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1915") +
                " " +
                this.$t("1916") +
                "<br>" +
                this.$t("1917", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("1918", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("1919"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1105) {
            this.$alert({
              content: this.$t("1875"),
              accept: this.$t("1876"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1335) {
            //아이디 계정 일시 정지(Suspend Account)
            // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
            this.$snackOpen({
              contents: this.$t("323"),
              btnDisplayYN: false,
            }).then(() => {});
          }
        });
    },
    signOutFirebase() {
      firebase.auth().signOut();
    },
  },
};
</script>